import { render, staticRenderFns } from "./DraftPriceAgreement.vue?vue&type=template&id=1135393b&"
import script from "./DraftPriceAgreement.vue?vue&type=script&lang=js&"
export * from "./DraftPriceAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports